import { useMutation, useQuery, useQueryClient, UseQueryOptions } from 'react-query'
import { FeaturesResponse, getFeatures, reportFeatureFlagUsage } from './featuresApi'

export const FEATURES_QUERY_KEY = ['features']

type FeaturesQueryOptions = Omit<
  UseQueryOptions<FeaturesResponse, unknown, FeaturesResponse, string[]>,
  'queryKey' | 'queryFn'
>

export const useFeaturesQuery = (options: FeaturesQueryOptions = {}) => {
  return useQuery({
    queryKey: FEATURES_QUERY_KEY,
    queryFn: getFeatures,
    staleTime: 60 * 1000,
    ...options,
  })
}

export const useFeatureFlagUsageMutation = () => {
  return useMutation(({ featureId, treatment }: { featureId: string; treatment: string }) =>
    reportFeatureFlagUsage(featureId, treatment).catch((error) => {
      console.debug(`Failed to report usage of feature flag '${featureId}'`, error)
    })
  )
}

export const useFeaturesInvalidator = () => {
  const queryClient = useQueryClient()
  return {
    invalidateFeatures: () => queryClient.invalidateQueries(FEATURES_QUERY_KEY),
  }
}
